import { forwardRef } from 'react';
import { FormattedMessage } from 'react-intl';

interface ICalendarInputProps {
  label: string;
  name: string;
  hideLabel?: boolean;
}

type InputProps = React.DetailedHTMLProps<
  React.InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
> & ICalendarInputProps;

export const CalendarInput = forwardRef<HTMLInputElement, InputProps>((props, ref) => (
  <>
    <div className="form-group">
      <label htmlFor={props.name} className={props.hideLabel ? "form-label sr-only" : ""}>
        <FormattedMessage id={props.label ? props.label : 'calendar.select.month'}/>
      </label>
      {props.id}
      <div className="input-group">
      <input className="form-control datepicker" autoComplete="off"
        ref={ref}
        onChange={props.onChange}
        onClick={props.onClick}
        name={props.name} id={props.id} value={props.value}/>
      <button className="ui-datepicker-trigger">
        <i className='fa fa-calendar'></i>
        <span className='sr-only'><FormattedMessage id="button.open.calendar"/></span>
      </button>
      </div>
      <div aria-atomic="true" aria-live="polite">
        <div className="field-error" id="test1" >
          <i className="fa fa-warning mr-2"></i>
          <FormattedMessage id='categories.obligatory.info'/>
        </div>
      </div>
    </div>
   </>
));